module.exports = "<div class=\"js-dropdown-region editor editor_user\"></div>";


//////////////////
// WEBPACK FOOTER
// ../src/form/editors/templates/memberSelectEditor.hbs
// module id = 687
// module chunks = 0